module.exports = __webpack_public_path__ + "img/welcome-ei-intro.6d255ed7.jpg";